import { FC } from 'react';
import { Col, Row } from 'antd';
import { Spacer, TextHeadingSection } from 'components';
import { NewsletterInput } from 'components/NewsletterInput/NewsletterInput';

export const SectionDontMissOut: FC = () => {
	return (
		<Col>
			<Row justify={'center'}>
				<TextHeadingSection>Don't want to miss out ?</TextHeadingSection>
			</Row>
			<Row justify={'center'}>
				Register using your email address for updates on the Live Auction
			</Row>
			<Spacer height={'sm'} />
			<Row justify={'center'}>
				<NewsletterInput />
			</Row>
		</Col>
	);
};
